import React from 'react';

interface SidePaneLayoutProps {
  paneTitle: string;
  pane: React.ReactNode;
  children: React.ReactNode;
}

export default function SidePaneLayout(props: SidePaneLayoutProps) {
  if (!props.pane) return <>{props.children}</>;

  return (
    <div className="row g-0" style={{ minHeight: 0 }}>
      <div className="col-12 col-md-7 pe-md-4 overflow-auto">
        {props.children}
      </div>
      <div className="col-12 col-md-5 mt-3 mt-md-0 ps-md-4 border-start d-flex flex-column">
        <h6 className="text-uppercase text-muted small mb-2">{props.paneTitle}</h6>
        {props.pane}
      </div>
    </div>
  );
}
